import React from "react";
import { ArrowRight } from "lucide-react";

const AuthProvider = ({ onLogin }) => {
  return (
    <div className="min-h-screen bg-canopy-bg flex items-center justify-center px-4">
      <div className="max-w-md w-full">
        <div className="bg-white rounded-lg shadow-lg p-8">
          <div className="text-center mb-8">
            <div className="flex items-center justify-center mb-6">
              <img
                className="canopy-page-title-logo-sign-in"
                src="/Logo.png"
                alt="Greenlight Financial"
              />
            </div>
            <p className="text-canopy-textMuted">
              Sign in with your Greenlight account to access
            </p>
          </div>

          <div className="space-y-4">
            <button
              onClick={onLogin}
              className="w-full flex items-center justify-center px-4 py-3 bg-canopy-blue hover:bg-canopy-blueHover text-white font-medium rounded-lg transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-canopy-blue focus:ring-offset-2"
            >
              <img
                src="https://developer.microsoft.com/favicon.ico"
                alt="Microsoft"
                className="w-5 h-5 mr-3"
              />
              Sign In
              <ArrowRight className="ml-3 h-4 w-4" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthProvider;
